module.exports = __webpack_public_path__ + "img/1967.30227092.png";